import Controller from '@ember/controller';
import { get } from '@ember/object';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';

export default Controller.extend({
  contactsCache: service(),
  fundsService: service(),
  router: service(),

  save: task(function* () {
    let changeset = get(this, 'model.changeset');
    yield changeset.validate();
    if (get(changeset, 'isValid')) {
      try {
        this.fundsService.confirmValidFundToken();
        yield changeset.save();
        yield this.contactsCache.loadContacts({ forceLoad: true });
        this.router.transitionTo(
          'funds.fund.groups.group',
          get(changeset, 'newName'),
        );
      } catch (e) {
        if (get(this, 'model.record.errors.length') > 0) {
          get(this, 'model.record.errors').forEach(({ attribute, message }) => {
            changeset.pushErrors(attribute, message);
          });
        } else {
          throw e;
        }
      }
    }
  }).drop(),
});
